import { render, staticRenderFns } from "./OtherTeamTank.vue?vue&type=template&id=e7fba15c&scoped=true&"
import script from "./OtherTeamTank.vue?vue&type=script&lang=js&"
export * from "./OtherTeamTank.vue?vue&type=script&lang=js&"
import style0 from "./OtherTeamTank.vue?vue&type=style&index=0&id=e7fba15c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7fba15c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VContainer,VHover,VImg})
